/**
 * Avatar — deterministic colored initials. Port of `NBAvatar` from
 * shared.jsx. Two letters max, uppercase. Color falls back to a stable
 * hash if not provided so two avatars for the same name look identical.
 */
import type { CSSProperties } from 'react';

const PALETTE = [
  '#0e874b',
  '#cc6726',
  '#257bea',
  '#ba7517',
  '#7a5ae0',
  '#1e51ae',
  '#993c1d',
  '#5d675d',
];

function hashColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

function initials(name: string): string {
  return (name || '?')
    .split(/\s+/)
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export interface AvatarProps {
  name: string;
  color?: string;
  size?: number;
  className?: string;
}

export function Avatar({ name, color, size = 22, className }: AvatarProps) {
  const bg = color || hashColor(name);
  const style: CSSProperties = {
    background: bg,
    width: size,
    height: size,
    fontSize: Math.max(9, Math.round(size * 0.42)),
  };
  return (
    <span className={`nb-avatar ${className ?? ''}`} style={style} aria-label={name}>
      {initials(name)}
    </span>
  );
}
